import { useEffect, useState } from "react";
import { getSubmittedForms } from "../../services/forms";
import { openSnackAlert } from "../../helper";
import CustomHeading from "../../components/customHeading";
import PaginatedTable from "../../components/dynamicTable";
import { Box } from "@mui/material";
import ViewSubmittedFormDialog from "./viewSubmittedFormDialog";
import { generateFormPDF } from "../../utils/generateFormPDF";
import AppLoader from "../../components/appLoader";

const tableHeaders = [
  { title: "Form Title", value: "title", align: "center" },
  { title: "Submitted By", value: "employee", align: "center" },
  { title: "Submission Date", value: "submissionDate", align: "center" },
  { title: "Download", value: "download", align: "center" },
  // { title: "View Submitted By", value: "actions", align: "center" },
];

const displayRows = tableHeaders.map((header) => header.value);

const SubmittedForm = () => {
  const [submittedForms, setSubmittedForms] = useState([]);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSubmittedForms(currentPage + 1, rowsPerPage);
  }, [currentPage, rowsPerPage]);

  const fetchSubmittedForms = async (page = 1, limit = 10) => {
    try {
      setLoading(true);
      const response = await getSubmittedForms(page, limit);
      if (response?.status === 200 || response?.status === 201) {
        const responseData = response.data?.data || {};
        const activities = responseData.activities || [];
        const pagination = responseData.pagination || {};

        const transformedForms = activities.map((form) => ({
          ...form,
          title: form.customFormId?.title || form.name || "-",
          workerId: form.workerId || null,
        }));

        setSubmittedForms(transformedForms);
        setTotalRecords(pagination.total || 0);
      } else {
        openSnackAlert(response?.message || "Something went wrong", "error");
      }
    } catch (error) {
      openSnackAlert("Something went wrong while fetching forms", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleViewForm = (form) => {
    setSelectedForm(form);
    setViewDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setViewDialogOpen(false);
    setSelectedForm(null);
  };

  const handleDownload = (form) => {
    generateFormPDF(
      form,
      (filename) => {
        openSnackAlert("PDF downloaded successfully", "success");
      },
      (error) => {
        console.error("Error generating PDF:", error);
        openSnackAlert("Failed to generate PDF", "error");
      }
    );
  };

  return (
    <>
      <Box
        bgcolor="primary.bgLight"
        padding={"20px"}
        borderRadius={"22px"}
        mt={0}
      >
<AppLoader isVisible={loading} />

        <CustomHeading
          tittle="Daily Activity Management"
          subtittle="Manage and track daily activities of your employees"
        />

        <Box mt={3}>
          <PaginatedTable
            tableHeader={tableHeaders}
            tableData={submittedForms}
            displayRows={displayRows}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalRecords={totalRecords}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onViewClick={handleViewForm}
            handleDownload={handleDownload}
          />
        </Box>
      </Box>

      <ViewSubmittedFormDialog
        open={viewDialogOpen}
        onClose={handleCloseDialog}
        formData={selectedForm}
      />
    </>
  );
};

export default SubmittedForm;
